module.exports = __webpack_public_path__ + "img/refreshActive.de7c0716.svg";